export default "__VITE_ASSET__C9moLsat__"